<template>
    <transition  >
    <div class="container-fluid ">
        <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Appointments </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Create Appointment</a></li>
                                
                            </ol>
                        </div>
                        <div class="page-title-right float-right "> 
                            <button type="button" class="btn btn-primary float-right" @click="redirectRoute('/appointments')">
                                <i class="fas fa-arrow-right"></i> All Appointments
                            </button>
                            <button type="button" class="btn btn-success float-right me-2" @click="redirectRoute('/today-appointments')">
                                <i class="fas fa-arrow-right"></i> Today Appointments
                            </button>

                        </div>
                    </div>
                </div>
            </div>  
            <div class="row">
                <!-- Appointment/Patient Registration -->
                <div class="col-12">
                    <!-- Content area -->
                    <div class="card" v-if="!loading">
                        <div class="card-header">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="type-radio" v-if="!editMode">
                                    <label class="me-2"><input type="radio" name="appointment_type" value="appointment" v-model="form.appointment_type"> Appointment</label>
                                    <label><input type="radio" name="appointment_type" value="registration" v-model="form.appointment_type"> Registration with Appointment</label>
                                </div>
                                <h3 style="text-align: center;">{{ (form.appointment_type == 'registration') ? 'Registration with Appointment' : 'Book An Appointment' }}</h3>
                            </div>
                        </div>

                        <div class="card-body" >
                            <div class="row">
                                <!-- Appointment Area -->
                                <div class="col-md-8 border-end">
                                    <div class="row mb-3">
                                        <div class="col-md-6">
                                            <label for="department_id" style="float: none;">Department *</label>
                                            <Multiselect 
                                                class="form-control border" 
                                                mode="single"
                                                v-model="form.department_id"
                                                placeholder="Select Department"  
                                                @change="onChangeDepartment($event)"
                                                :searchable="true" 
                                                :filter-results="true"
                                                :options="department_options"
                                                :classes="multiclasses"
                                                :close-on-select="true" 
                                                :min-chars="1"
                                                :resolve-on-load="false" 
                                                :create-option="true" 
                                            />                                                   
                                            <div class="invalid-feedback" v-if="errors.department_id">
                                                {{errors.department_id[0]}}
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <label for="doctor_id" style="float: none;">Doctor *</label>
                                            <Multiselect 
                                                class="form-control border" 
                                                mode="single"
                                                v-model="form.doctor_id"
                                                placeholder="Select Doctor"  
                                                :searchable="true" 
                                                :filter-results="true"
                                                :options="doctor_options"
                                                :classes="multiclasses"
                                                :close-on-select="true" 
                                                :min-chars="1"
                                                :resolve-on-load="false" 
                                                :create-option="true" 
                                                @change="onChangeDoctor($event)"
                                                v-if="renderOptionComponent"
                                            />                                                   
                                            <div class="invalid-feedback" v-if="errors.doctor_id">
                                                {{errors.doctor_id[0]}}
                                            </div>
                                        </div>                                        
                                    </div>

                                    <div class="row mb-3">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="appointment_date">Date *</label>
                                                <input type="date" class="form-control border" id="appointment_date" v-model="form.appointment_date" @input="onChangeDate($event.target.value)" @keypress="onkeyPress('appointment_date')" placeholder="Appointment Date"> 
                                                <div class="invalid-feedback" v-if="errors.appointment_date">
                                                    {{errors.appointment_date[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="schedule_id">Slot *</label>
                                                <select id="schedule_id" v-model="form.schedule_id" @change="onchangeSlot($event.target.value)" class="form-control border">
                                                    <option value="">Select Slot</option>
                                                    <!-- Options will be populated dynamically based on selected doctor and date -->
                                                    <option v-for="slot in slots" :key="slot.id" :value="slot.id">
                                                        {{ slot.label }} 
                                                    </option>
                                                </select>
                                                <div class="invalid-feedback" v-if="errors.schedule_id">
                                                    {{errors.schedule_id[0]}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">    
                                                <label for="appointment_time"> Appointment Time </label>
                                                <input type="time" class="form-control border" v-model="form.appointment_time" id="appointment_time" placeholder="Appointment Time">
                                                <div class="invalid-feedback" v-if="errors.appointment_time">
                                                    {{errors.appointment_time[0]}}
                                                </div>  
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-3">
                                        <div class="col-md-4">
                                            <div class="form-group">    
                                                <label for="reporting_time"> Reporting Time </label>
                                                <input type="time" class="form-control border" v-model="form.reporting_time" id="reporting_time" placeholder="Reporting Time">
                                                <div class="invalid-feedback" v-if="errors.reporting_time">
                                                    {{ errors.reporting_time[0] }}
                                                </div>  
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="type">Type *</label>
                                                <select id="type" v-model="form.type" @change="onChangeType($event.target.value)" class="form-control border">
                                                    <option value="">Select Type</option>
                                                    <option value="from_call"> From Call </option>
                                                    <option value="physical"> Physical </option>
                                                    <!- <option value="online"> Online </option> ->

                                                </select>
                                                <div class="invalid-feedback" v-if="errors.type">
                                                    {{errors.type[0]}}
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>

                                    <hr>

                                    <div class="row mb-3" v-if="form.appointment_type == 'registration'">
                                        <!-- <div class="col-md-6">
                                            <label for="patient_search" style="float: none;">Search Patient (Code/Phone) *</label>
                                            <div class="position-relative">
                                                <input type="text" 
                                                    class="form-control border" 
                                                    v-model="patient_search" 
                                                    id="patient_search" 
                                                    placeholder="Search by patient code or phone number" 
                                                    @keyup="searchPatient($event.target.value)"
                                                    @keydown="handleKeydown($event)">                                                  
                                                    <div class="invalid-feedback" v-if="errors.patient_search">
                                                        {{errors.patient_search[0]}}
                                                    </div>
                                                <!- Patient Search Results Dropdown ->
                                                <div class="patient-search-dropdown" v-if="filteredPatients.length > 0 && patient_search">
                                                    <ul class="list-group mt-2">
                                                        <li 
                                                            class="list-group-item d-flex justify-content-between align-items-center patient-item" 
                                                            v-for="(patient, index) in filteredPatients" 
                                                            :key="patient.id"
                                                            :class="{'active': index === selectedPatientIndex}"
                                                            style="cursor: pointer;"
                                                            @click="selectPatient(patient)"
                                                            @mouseover="selectedPatientIndex = index">
                                                            <span><strong>{{ patient.customer_code }}</strong> - {{ patient.name }} - {{ patient.phone }}</span>
                                                            <i class="fas fa-times" @click.stop="clearPatientSearch()" style="color: #dc3545; cursor: pointer;"></i>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div v-if="patient_search && filteredPatients.length === 0" class="alert alert-info mt-2" style="padding: 8px;">
                                                    No patients found
                                                </div>
                                            </div>
                                        </div> -->

                                        <div :class="form.patient_id ? 'col-md-9' : 'col-md-12'">
                                            <div class="input-group input-group-merge autocomplete">
                                                <input
                                                    type="text"
                                                    v-model="patient_search"
                                                    class="form-control"
                                                    placeholder="Search patient by name/code/phone"
                                                    @keyup="searchPatient"
                                                    @keyup.enter="patientAddToForm()"
                                                    @keydown.down="onArrowDown"
                                                    @keydown.up="onArrowUp"
                                                />
                                                <ul
                                                    v-if="filteredPatients.length > 0"
                                                    class="
                                                    w-full
                                                    rounded
                                                    bg-white
                                                    border border-gray-300
                                                    px-4
                                                    py-2
                                                    space-y-1
                                                    absolute
                                                    z-10
                                                    autocomplete-results
                                                    "
                                                >
                                                    
                                                    <li
                                                    v-for="(patient, i) in filteredPatients.slice(0, 15)"
                                                    :key="patient.id"
                                                    @change="selectPatient(patient)"
                                                    @click="setResult(patient)"
                                                    class="cursor-pointer hover:bg-gray-100 p-1"
                                                    :class="{ isActive: i === arrowCounter }"
                                                    >
                                                        <span><strong>{{ patient.customer_code }}</strong> - {{ patient.name }} - {{ patient.phone }}</span>

                                                    </li>
                                                </ul>
                                            </div>
                                            <div v-if="patient_search && filteredPatients.length === 0" class="alert alert-info mt-2" style="padding: 8px;">
                                                No patients found
                                            </div>
                                        </div>

                                        <div class="col-md-3" v-if="form.patient_id">
                                            <button type="button" class="btn btn-danger" @click="clearPatientInfo" style="margin-top: 0; width: 100%;">
                                                <i class="fas fa-times"></i> Clear Patient info
                                            </button>
                                        </div>
                                    </div>

                                    <div class="row mb-3">
                                        <div class="col-md-4">
                                            <label for="patient_name" style="float: none;">Patient *</label>
                                            <input type="text" class="form-control border" v-model="form.patient_name" id="patient_name" placeholder="Patient Name Here!" @keypress="onkeyPress('patient_name')">                                                  
                                            <div class="invalid-feedback" v-if="errors.patient_name">
                                                {{errors.patient_name[0]}}
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <label for="patient_phone" style="float: none;">Patient Phone </label>
                                            <input type="text" class="form-control border" v-model="form.patient_phone" id="patient_phone" placeholder="Phone number Here!" @keypress="onkeyPress('patient_phone')">                                                  
                                            <div class="invalid-feedback" v-if="errors.patient_phone">
                                                {{errors.patient_phone[0]}}
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <label for="patient_age" style="float: none;">Patient Age </label>
                                            <div class="d-flex gap-2">
                                                <input type="number"
                                                    class="form-control"
                                                    placeholder="Years"
                                                    min="0"
                                                    v-model.number="age.years"
                                                    @input="validateAge('years'), updateAge()">

                                                <input type="number"
                                                    class="form-control"
                                                    placeholder="Months"
                                                    min="0"
                                                    max="11"
                                                    v-model.number="age.months"
                                                    @input="validateAge('months'), updateAge()">

                                                <input type="number"
                                                    class="form-control"
                                                    placeholder="Days"
                                                    min="0"
                                                    max="30"
                                                    v-model.number="age.days"
                                                    @input="validateAge('days'), updateAge()">
                                            </div>
                                            <input type="hidden" v-model="form.patient_age">       
                                            <small class="text-muted">
                                                {{ form.patient_age ?? '' }}
                                            </small>                                           
                                            <div class="invalid-feedback" v-if="errors.patient_age">
                                                {{ errors.patient_age[0] }}
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <label for="patient_gender" style="float: none;">Patient Gender </label>
                                            <select id="patient_gender" class="form-select border" v-model="form.patient_gender">
                                                <option value="" disabled selected>Select Gender</option>
                                                <option value="male">Male</option>
                                                <option value="female">Female</option>
                                            </select>
                                            <div class="invalid-feedback" v-if="errors.patient_gender">
                                                {{ errors.patient_gender[0] }}
                                            </div>
                                        </div>

                                        <div class="col-md-12 mt-2" v-if="form.appointment_type == 'registration'">
                                            <div class="row mb-2">
                                                <div class="col-md-4">
                                                    <label for="patient_dob" style="float: none;">Date of Birth</label>
                                                    <input type="date" class="form-control border" v-model="form.patient_dob" id="patient_dob" placeholder="Patient DOB" @keypress="onkeyPress('patient_dob')">
                                                    <div class="invalid-feedback" v-if="errors.patient_dob">
                                                        {{ errors.patient_dob[0] }}
                                                    </div>
                                                </div>

                                                <div class="col-md-4">
                                                    <label for="patient_father_husband" style="float: none;">Father/Husband Name </label>
                                                    <input type="text" class="form-control border" v-model="form.patient_father_husband" id="patient_father_husband" placeholder="Father/Husband name Here!" @keypress="onkeyPress('patient_father_husband')">                                                  
                                                    <div class="invalid-feedback" v-if="errors.patient_father_husband">
                                                        {{ errors.patient_father_husband[0] }}
                                                    </div>
                                                </div>

                                                <div class="col-md-4">
                                                    <label for="doctor_id" style="float: none;">District </label>
                                                    <Multiselect 
                                                        class="form-control border" 
                                                        mode="single"
                                                        v-model="form.district_id"
                                                        placeholder="Select District"  
                                                        :searchable="true" 
                                                        :filter-results="true"
                                                        :options="district_options"
                                                        :classes="multiclasses"
                                                        :close-on-select="true" 
                                                        :min-chars="1"
                                                        :resolve-on-load="false" 
                                                        :create-option="true" 
                                                        @change="onChangeDisctrict($event)"
                                                        v-if="renderOptionComponent"
                                                    />                                                   
                                                    <div class="invalid-feedback" v-if="errors.district_id">
                                                        {{errors.district_id[0]}}
                                                    </div>
                                                </div> 
                                            </div>

                                            <div class="row">
                                                <div class="col-md-4">
                                                    <label for="doctor_id" style="float: none;">Upazila </label>
                                                    <Multiselect 
                                                        class="form-control border" 
                                                        mode="single"
                                                        v-model="form.upazila_id"
                                                        placeholder="Select Upazila"  
                                                        :searchable="true" 
                                                        :filter-results="true"
                                                        :options="upazila_options"
                                                        :classes="multiclasses"
                                                        :close-on-select="true" 
                                                        :min-chars="1"
                                                        :resolve-on-load="false" 
                                                        :create-option="true" 
                                                        v-if="renderOptionComponent"
                                                    />                                                   
                                                    <div class="invalid-feedback" v-if="errors.upazila_id">
                                                        {{errors.upazila_id[0]}}
                                                    </div>
                                                </div>
                                                
                                                <div class="col-md-8">
                                                    <label for="patient_address" style="float: none;">Address </label>
                                                    <input type="text" class="form-control border" v-model="form.patient_address" id="patient_address" placeholder="Address Here!" @keypress="onkeyPress('patient_address')">                                                  
                                                    <div class="invalid-feedback" v-if="errors.patient_address">
                                                        {{ errors.patient_address[0] }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>




                                        <!-- <div class="col-md-4 mt-3">
                                            <div class="form-group">    
                                                <label for="p-status">Status *</label>
                                                <select id="p-status" v-model="form.status" class="form-control border">
                                                    <option value="0"> Pending </option>
                                                    <!- <option value="1"> Confirmed </option> ->
                                                    <option value="2"> Present </option>
                                                </select>
                                                <div class="invalid-feedback" v-if="errors.status">
                                                    {{errors.status[0]}}
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>

                                    <div class="payment_area" v-if="form.appointment_type == 'registration'">
                                        <hr>
                                        <div class="row mb-3">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="paying_by">Paying by *</label>
                                                    <select id="paying_by" v-model="form.payment_type" class="form-control border">
                                                        <option value="cash">Cash</option>
                                                        <option value="card">Card</option>
                                                    </select>
                                                    <div class="invalid-feedback" v-if="errors.payment_type">
                                                        {{errors.payment_type[0]}}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="amount">Amount *</label>
                                                    <input type="number" step="any" onmousewheel="return false" v-model="form.amount" id="amount" @keypress="onkeyPress('amount')" class="form-control" />
                                                    <div class="invalid-feedback" v-if="errors.amount">
                                                        {{errors.amount[0]}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Appointment Schedule Area -->
                                <div class="col-md-4">
                                    <div class="card border">
                                        <div class="card-header bg-primary text-white">
                                            <h5 style="text-align: center; margin:0;">Doctor Schedule</h5>
                                        </div>
                                        <div class="card-body">
                                            <table class="table table-bordered mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Day</th>
                                                        <th>Time</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="schedules.length > 0">
                                                    <tr v-for="schedule in schedules" :key="schedule.id" :class="{'table-success': schedule.isMatching}">
                                                        <td>{{ schedule.weekday }}</td>
                                                        <td>{{ new Date('1970-01-01 ' + schedule.start_time).toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', hour12: true }) }} - {{ new Date('1970-01-01 ' + schedule.end_time).toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', hour12: true }) }}</td>
                                                    </tr>
                                                    <tr v-if="schedules.filter(s => s.doctor_id === form.doctor_id).length === 0">
                                                        <td colspan="2" style="text-align: center;">No schedule available for selected doctor.</td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-else-if="form.doctor_id && schedules.length == 0">
                                                    <tr>
                                                        <td colspan="2" style="text-align: center;">No schedule available for selected doctor.</td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-else>
                                                    <tr>
                                                        <td colspan="2" style="text-align: center;">No schedule available. Please select a doctor.</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="card border" v-if="!editMode || (editMode && (appointment.doctor_id != form.doctor_id) || (appointment.appointment_date != form.appointment_date))">
                                        <div class="card-header bg-success text-white">
                                            <h5 style="text-align: center; margin:0;">Available Slots</h5>
                                        </div>
                                        <div class="card-body">
                                            <table class="table table-bordered mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Time</th>
                                                        <th>Book</th>
                                                        <th>Cancel</th>
                                                        <th>Available</th>
                                                        <th>Serial</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="slot in slots" :key="slot.id" :class="{'table-success': slot.isMatching}">
                                                        <td class="fw-bold"><small>{{ slot.label }}</small></td>
                                                        <td class="text-center">{{ slot.appointments_count }}</td>
                                                        <td class="text-center">{{ slot.canceled_count }}</td>
                                                        <td class="text-center">{{ slot.available }}</td>
                                                        <td class="text-center">{{ slot.next_serial }}</td>
                                                    </tr>
                                                    <tr v-if="slots.length === 0">
                                                        <td colspan="5" style="text-align: center;">No slots available for selected date.</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            
                            </div>
                        </div>

                        <div class="card-footer text-center">
                            <button type="button" class="btn btn-danger px-4 me-2" @click="resetForm()">
                                Reset
                            </button> 
                            <button type="submit" @click="submitForm" class="btn btn-primary px-4" :disabled="disabled">
                                <span v-show="isSubmit">
                                    <i class="fas fa-spinner fa-spin" ></i>
                                </span> {{btn}} 
                            </button> 
                        </div>
                    </div>

                    <div class="tab-pane show active" v-if="loading">
                        <div class="row"> 
                            <div class="col-md-5">  
                            </div>
                            <div class=" col-md-2"> 
                                <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                            </div>
                            <div class="col-md-5">  
                            </div>
                        </div>
                    </div>

                </div>
            </div> 

            <!-- Token Print Modal-->
            <Modal @close="toggleTokenPrintModal()" :modalActive="tokenPrintModalActive">
            <!-- <Modal @close="toggleTokenPrintModal()"> -->
                <div class="modal-content scrollbar-width-thin appointment-print" >
                    <div class="modal-header"> 
                        <h3 style="width: 100%">Appointment Token</h3>
                        <button style="float: right;" @click="toggleTokenPrintModal()" type="button" class="btn btn-danger">X</button>
                    </div>
                    <div class="modal-body " id="printTokenArea" >
                        <div id="printTokenReceipt">
                            <div class="page">
                                <!-- HEADER -->
                                <div class="header">
                                    <h2>{{ this.prescriptionHospitalName }}</h2>
                                    <small>{{ this.prescriptionAddress }}<br>
                Phone: {{ this.prescriptionPhone }} | Email: {{ this.prescriptionEmail }}</small>
                                </div>

                                <!-- PATIENT BASIC INFO -->
                                <div class="section">
                                    <div>
                                        <h4 style="text-align: center; margin-top: -10px; padding: 10px 15px; display: block;"><strong style="background-color: #282828; color: #fff; padding: 8px 15px;">OUT-PATIENT RECORD</strong></h4>
                                    </div>
                                    <div class="row">

                                        <div class="col-50 patient_app_info">
                                            <div><span class="label">MR No:</span> {{ appointment.patients ? appointment.patients.customer_code : '' }}</div>
                                            <div><span class="label">Name:</span> {{ appointment.patient_name }}</div>
                                            <div><span class="label">Age:</span> {{ appointment.patient_age }}</div>
                                            <div><span class="label">Gender:</span> {{ appointment.patient_gender }}</div>
                                            <div><span class="label">Address:</span> {{ appointment.patients ? appointment.patients.address : '' }}</div>
                                            <div><span class="label">Cell:</span> {{ appointment.patient_phone }}</div>
                                        </div>
                                        <div class="col-50 patient_app_info">
                                            <div><span class="label">Bill No:</span> {{ appointment.serial_no }}</div>
                                            <div><span class="label">Date:</span> {{ this.formatDate(appointment.appointment_date) }}</div>
                                            <div><span class="label">Time:</span> {{ this.formatAppointmentTime(appointment.appointment_time) }}</div>
                                            <div><span class="label">Email:</span> {{ appointment.patients ? appointment.patients.email : '' }}</div>
                                            <div><span class="label">Referred By:</span> </div>
                                            <div><span class="label">Operator:</span> {{ loggedInUser.name }}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="divider"></div>
                                <!-- CLINICAL PART -->
                                <div class="section">
                                    <div><span class="label">Chief Complaint:</span></div>
                                    <div class="line-box"></div>

                                    <div><span class="label">Present History:</span></div>
                                    <div class="line-box"></div>

                                    <div><span class="label">Past Ocular History:</span></div>
                                    <div class="line-box"></div>

                                    <div><span class="label">Medical History:</span>
                                        HPN ☐ Cardiac ☐ DM ☐ Thyroid ☐ Asthma ☐ Other ☐
                                    </div>
                                    <div class="line-box"></div>
                                </div>

                                <!-- VISION TABLE -->
                                <div class="section">
                                </div>

                                <!-- CUT LINE -->
                                <div class="dashed"></div>

                                <!-- BOTTOM PART -->
                                <div class="section row">

                                    <!-- LEFT TEXT / NOTE AREA -->
                                    <div class="col-60 pe-0">
                                        <div class="receipt">
                                            <div class="receipt-header">
                                                {{ this.prescriptionHospitalName }}<br>
                                                <small style="font-size: 8px;">{{ this.prescriptionAddress }}
                Phone: {{ this.prescriptionPhone }} | Email: {{ this.prescriptionEmail }}</small>
                                            </div>

                                            <table style="border-right: 0">
                                                <tr>
                                                    <td style="border-left: 0;"><strong>MR No: </strong> {{ appointment.patients ? appointment.patients.customer_code : '' }}</td>
                                                    <td style="border-right: 0;"><strong>Date: </strong> {{ this.formatDate(appointment.appointment_date) }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="border-left: 0; border-right: 0;"><strong>Name: </strong> {{ appointment.patient_name }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="border-left: 0; border-right: 0;"><strong>Address: </strong> {{ appointment.patients ? appointment.patients.address : '' }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="height: 16px; border-left: 0; border-right: 0;"></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="height:60px; font-size:10px; border-left: 0; border-right: 0; border-bottom: 0;">
                                                        রোগীকে ডাক্তারের পরামর্শ অনুযায়ী প্রয়োজনীয় পরীক্ষা করাতে হবে।<br>
                                            নির্ধারিত তারিখে রিপোর্টসহ উপস্থিত থাকতে হবে।
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>

                                    <!-- MONEY RECEIPT (IMAGE MATCHED) -->
                                    <div class="col-40 ps-0">
                                        <div class="receipt">
                                            <div class="receipt-header">
                                                {{ this.prescriptionHospitalName }}<br>
                                                <small>Out-Patient Record</small>
                                            </div>

                                            <table>
                                                <tr>
                                                    <!-- <td style="border-left: 0;"><strong>MR No: </strong> {{ appointment.patients ? appointment.patients.customer_code : '' }}</td> -->
                                                    <td colspan="2" style="border-left: 0; border-right: 0;"><strong>Receipt No: </strong> {{ appointment.serial_no }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="border-left: 0; border-right: 0;"><strong>Name: </strong> {{ appointment.patient_name }}</td>
                                                </tr>
                                                <tr>
                                                    <td style="border-left: 0;"><strong>Details</strong></td>
                                                    <td style="border-right: 0; text-align: center;">Amount (TK)</td>
                                                </tr>
                                                <tr style="height: 38px;">
                                                    <td style="border-left: 0;">Consulting Fees</td>
                                                    <td style="border-right: 0; text-align: right; font-weight: 600;">{{ appointment.receivable_amount }}</td>
                                                </tr>
                                                <tr style="height: 38px;">
                                                    <td style="border-left: 0; border-bottom: 0;">
                                                        <span style="display: block; padding-left: 30px;">{{ this.formatDate(appointment.appointment_date) }} </span>
                                                        <span style="display: block; margin-left: 20px; width: 80%; border-top:1px solid #ccc;"></span>
                                                        <strong style="display: block; padding-left: 20px;">Date</strong>
                                                    </td>
                                                    <td style="border-right: 0; border-bottom: 0;">
                                                        <span style="display: block; padding-left: 30px;">{{ loggedInUser.name }}</span>
                                                        <span style="display: block; margin-left: 20px; width: 80%; border-top:1px solid #ccc;"></span>
                                                        <strong style="display: block; padding-left: 20px;">Cashier</strong>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <!-- <div class="appointment_token" style="text-align: center;" v-if="tokenPrintModalActive">
                            <h3 style="text-align: center;">{{ (appointment.serial_no).slice(-4) }}</h3>
                            <h5 style="text-align: center;">Patient: {{ appointment.patient_name }}</h5>
                            <p style="text-align: center;">Doctor: {{ appointment.doctor_name }}</p>
                            <p style="text-align: center;">Department: {{ appointment.department_name }}</p>
                            <p style="text-align: center;">Date: {{ appointment.appointment_date }}</p>
                        </div> -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click="toggleTokenPrintModal()">
                            Close
                        </button> 
                        <button type="button" class="btn btn-primary " @click="printContent('printTokenArea', print_ar_css_url)">
                            <i class="fas fa-print" ></i> Print Token
                        </button>
                    </div>
                </div>
            </Modal>

        </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "../../helper/Modal";
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { ref, onMounted } from "vue";
import Form from 'vform'
import axios from 'axios';
import { type } from "jquery";
export default {
    name: 'Appointments',
    components: {
        Modal,
        Datatable,
        Pagination,
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            tokenPrintModalActive:false,
            loggedInUser: this.$store.getters.userData.user || '',
            print_ar_css_url: this.baseUrlPrintCSS + '/assets/css/print_appointment_registration_invoice.css',
            errors: {},
            imagePreview: '',
            btn:'Create',
            renderOptionComponent: true,
            items: [],
            appointment_id: this.$route.query.appointment_id || null,
            app_query_type: this.$route.query.type || null,
            app_redirect_url: this.$route.query.redirect || null,
            appointment: {},
            appointments: [],
            patients: [],
            patient_options: [],

            patient_search: '',
            searchTimer: null,
            arrowCounter: -1,
            filteredPatients: [],
            selectedPatient: "",

            doctors: [],
            doctor_options: [],
            departments: [],
            department_options: [],
            schedules: [],
            slots: [],
            districts: [],
            district_options: [],
            upazilas: [],
            upazila_options: [],
            loading: true,
            companies: [],
            form: new Form({
                id: '',
                department_id: '',
                doctor_id: '',
                appointment_date: '', 
                schedule_id: '',
                appointment_time: '',
                reporting_time: '',  
                type: 'from_call',
                appointment_type: 'appointment',
                patient_id: '', 
                patient_name: '', 
                patient_phone: '', 
                patient_age: '',
                patient_gender: '',
                patient_dob: '',
                patient_father_husband: '',
                district_id: '',
                upazila_id: '',
                patient_address: '',
                payment_type: 'cash',
                amount: '',
            }),
            age: {
                years: '',
                months: '',
                days: '',
            },
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },

        };
    },
    created() {
        this.fetchDepartments();
        this.fetchDoctors();
        this.fetchDistrict();
        this.fetchArea();
        if(this.appointment_id) {
            this.onLoadAppointment(this.appointment_id);
        }

        // console.log("appointment_id==", this.$route.query);
    },
    methods: { 
        forceRerender() {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;
            });
        },

        redirectRoute(url) {
            this.$router.push({ path: url });
        },


         
        toggleTokenPrintModal: function() {  
            this.tokenPrintModalActive = !this.tokenPrintModalActive;
            if(this.tokenPrintModalActive) {
                setTimeout(() => {
                    this.printContent('printTokenArea', this.print_ar_css_url);
                    this.tokenPrintModalActive = false;
                }, 2000);
            }
        },

        tokenPrint: function(item) {  
            this.appointment = item;
            this.toggleTokenPrintModal();
        },

        printContent(document_id, css_url='') {
            const width = 900;
            const height = 650;
            const left = (screen.width / 2) - (width / 2);
            const top = (screen.height / 2) - (height / 2);

            const options = {
                name: '_blank',
                specs: [
                    `width=${width}`,
                    `height=${height}`,
                    `top=${top}`,
                    `left=${left}`,
                    'scrollbars=yes',
                    'resizable=yes',
                    'titlebar=yes'
                ],
                styles: [
                    this.baseUrlPrintCSS + '/assets/css/bootstrap-print.min.css',
                    css_url
                ],
            };

            this.$htmlToPaper(document_id, options);
        },

        async fetchCompany() { 
            axios.get(this.apiUrl+'/companies', this.headerjson)
            .then((res) => {
                this.companies = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }); 
        }, 

        async fetchPatients() { 
            axios.get(this.apiUrl+'/hm/patients', this.headerjson)
            .then((res) => {
                this.patients = res.data.data;
                // this.patient_options = [{label: "Select Patient", value: ""}];
                res.data.data.map((item) => {
                    this.patient_options.push({label:item.name + " - " + item.phone, value:item.id});
                }); 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }).finally((ress) => {
                this.loading = false;
            });
        }, 
        async fetchDepartments() { 
            axios.get(this.apiUrl+'/hm/departments', this.headerjson)
            .then((res) => {
                this.departments = res.data.data; 
                // this.department_options = [{label: "Select Department", value: ""}];
                res.data.data.map((item) => {
                    this.department_options.push({label:item.name, value:item.id});
                });
            }) 
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            })
        }, 

        async fetchDoctors() {
            axios.get(this.apiUrl+"/hm/doctors", this.headerjson)
            .then((resp) => {
                this.doctors  = resp.data.data;
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            })
            .finally(() => {
                this.loading = false;
            });
        },

        
        async fetchDistrict() { 
            axios.get(this.apiUrl+'/districts', this.headerjson)
            .then((res) => {
                this.districts = res.data.data; 
                this.district_options = res.data.data.map((item) => {
                    return {label: item.name, value:item.id}
                })
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            });
        },

        async fetchArea() { 
            axios.get(this.apiUrl+'/areas',this.headerjson)
            .then((res) => {
                this.upazilas = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            });
        }, 

        onChangeDepartment(dept_id) {
            this.schedules = [];
            this.form.department_id = dept_id;
            this.doctor_options = [];
            this.form.doctor_id = '';
            this.form.appointment_date = '';
            this.slots = [];
            this.form.schedule_id = '';
            this.form.appointment_time = '';
            this.form.reporting_time = '';
            this.form.type = 'physical';
            this.forceRerender();
            if(dept_id != 0) {
                let department_doctors = this.doctors.filter((item, index) => {
                    return item.department_id == dept_id;
                });

                if(department_doctors.length > 0) {
                    this.doctor_options = department_doctors.map((item) => { 
                        return {label:item.name, value:item.id};
                    });
                }
            }

        },

        onChangeDoctor(val) {
            this.schedules = [];
            this.form.doctor_id = val;
            this.form.appointment_date = '';
            this.slots = [];
            this.loadSchedules();
        },

        onChangeDate(val) {
            this.slots = [];
            this.form.schedule_id = '';
            this.form.appointment_date = val;
            this.form.appointment_time = '';
            this.form.reporting_time = '';
            this.loadSlots();
            this.highlightMatchingSchedule('schedule');
        },

        onchangeSlot(val) {
            this.form.schedule_id = val;
            this.appointment_time = '';
            this.reporting_time = '';
            this.appointmentTimeSchedule();
            this.highlightMatchingSchedule('slot');
        },

        onChangeType(val) {
            this.form.type = val;
            if(val != 'physical') {
                this.form.payment_type = '';
                this.form.amount = '';
                this.form.status = 0;
            }else{
                this.form.payment_type = 'cash';
                this.form.status = 2;
            }
        },

        onChangeDisctrict(val) {
            this.form.upazila_id = '';
            this.upazila_options = [];
            const upazila_data = this.upazilas.filter((item) => item.district_id == val);
            if(upazila_data) {
                this.upazila_options = upazila_data.map((item) => {
                    return {label:item.name, value:item.id}
                });
            }
        },

        appointmentTimeSchedule() {
            let selectedSlot = this.slots.find(slot => slot.id == this.form.schedule_id);

            console.log(selectedSlot, this.form.schedule_id);

            if (selectedSlot) {
                // Set appointment time based on slot start time and patient count
                const slotStartTime = new Date(`1970-01-01 ${selectedSlot.start_time}`);
                const slotEndTime = new Date(`1970-01-01 ${selectedSlot.end_time}`);
                const slotDurationMs = slotEndTime.getTime() - slotStartTime.getTime();
                const patientCount = selectedSlot.appointments_count || 0;
                const timePerPatient = slotDurationMs / (selectedSlot.available + patientCount);
                const appointmentTime = new Date(slotStartTime.getTime() + (patientCount * timePerPatient));
                this.form.appointment_time = appointmentTime.toLocaleTimeString('en-US', { 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    hour12: false 
                }).substring(0, 5);
                
                // Calculate reporting time (15 minutes before appointment time)
                const reportingTime = new Date(appointmentTime.getTime() - 15 * 60000);
                this.form.reporting_time = reportingTime.toLocaleTimeString('en-US', { 
                    hour: '2-digit', 
                    minute: '2-digit', 
                    hour12: false 
                }).substring(0, 5);
            }

            console.log("sdfsjhdjf==", this.form.appointment_time, this.form.reporting_time);
        },

        highlightMatchingSchedule(type) {

            if(type === 'slot') {
                const selectedSlot = this.slots.find(slot => slot.id == this.form.schedule_id);
                if (!selectedSlot) return;
                this.slots = this.slots.map(slot => {
                    return {
                        ...slot,
                        isMatching: slot.id == this.form.schedule_id
                    };
                });
            }
            else if(type === 'schedule') {
                const selectedDate = new Date(this.form.appointment_date);
                const options = { weekday: 'short' };
                const selectedWeekday = selectedDate.toLocaleDateString('en-US', options);
                this.schedules = this.schedules.map(schedule => {
                    return {
                        ...schedule,
                        isMatching: schedule.weekday == selectedWeekday
                    };
                });
            }
            else {
                this.schedules = this.schedules.map(schedule => {
                    return {
                        ...schedule,
                        isMatching: false
                    };
                });
                this.slots = this.slots.map(slot => {
                    return {
                        ...slot,
                        isMatching: false
                    };
                });
            }
            
        },

        parseAge(ageString) {
            if(!ageString) {
                this.age.years = '';
                this.age.months = '';
                this.age.days = '';
                return;
            }
            const match = ageString.match(/(\d+)y\s*(\d+)m\s*(\d+)d/)
            if (match) {
                this.age.years  = Number(match[1])
                this.age.months = Number(match[2])
                this.age.days   = Number(match[3])
            }else{
                if(ageString) {
                    this.age.years = ageString;
                    this.updateAge();
                }
            }
        },

        validateAge(field) {
            if(field === 'years' && this.age.years < 0) {
                this.age.years = 0;
            }
            if(field === 'months') {
                if(this.age.months < 0) {
                    this.age.months = 0;
                } else if(this.age.months > 11) {
                    this.age.months = 11;
                }
            }
            if(field === 'days') {
                if(this.age.days < 0) {
                    this.age.days = 0;
                } else if(this.age.days > 29) {
                    this.age.days = 29;
                }
            }
        },

        updateAge() {
            let y = this.age.years || 0
            let m = this.age.months || 0
            let d = this.age.days || 0

            this.form.patient_age = `${y}y ${m}m ${d}d`
        },


        async searchPatient(event) {

            if (['ArrowUp', 'ArrowDown', 'Enter'].includes(event.code)) return;
            const query = event.target.value?.trim();
            clearTimeout(this.searchTimer);
            if (!query) {
                this.filteredPatients = [];
                return;
            }
            this.searchTimer = setTimeout(async () => {
                try {
                    const res = await axios.get(
                        this.apiUrl + '/hm/patients/search',
                        {
                            params: { query },
                            ...this.headerjson
                        }
                    );

                    this.filteredPatients = res.data.data;
                } catch (e) {
                    console.error(e);
                }
            }, 500); // wait until user stops typing
        },

        async searchPatientByNameOrPhone(payload) {
            if (!payload) {
                this.filteredPatients = [];
                return;
            }
            try {
                const res = await axios.get(
                    this.apiUrl + '/hm/patients/search',
                    {
                        params: { type: 'name_or_phone', ...payload },
                        ...this.headerjson
                    }
                );

                this.filteredPatients = res.data.data;
            } catch (e) {
                console.error(e);
            }
        },

        patientAddToForm() {
            console.log("selectedPatient==", this.selectedPatient);
            if(this.selectedPatient) {
                this.setResult(this.selectedPatient);
            }
        },

        onArrowDown: function (event) {
            if (this.filteredPatients.length > 0) {
                this.arrowCounter =
                event.code == "ArrowDown" ? ++this.arrowCounter : --this.arrowCounter;
                if (this.arrowCounter >= this.filteredPatients.length)
                this.arrowCounter = this.arrowCounter % this.filteredPatients.length;
                else if (this.arrowCounter < 0)
                this.arrowCounter = this.filteredPatients.length + this.arrowCounter;
                this.selectPatient(this.filteredPatients[this.arrowCounter]);
                // this.singlePatientItem = this.filteredPatients[this.arrowCounter];
            }
        },
        onArrowUp: function (event) {
            if (this.filteredPatients.length > 0) {
                this.arrowCounter =
                event.code == "ArrowUp" ? --this.arrowCounter : ++this.arrowCounter;
                if (this.arrowCounter >= this.filteredPatients.length)
                this.arrowCounter = this.arrowCounter % this.filteredPatients.length;
                else if (this.arrowCounter < 0)
                this.arrowCounter = this.filteredPatients.length + this.arrowCounter;
                this.selectPatient(this.filteredPatients[this.arrowCounter]);
                // this.singlePatientItem = this.filteredPatients[this.arrowCounter];
            }
        },

        selectPatient(patient) {
            this.selectedPatient = patient;
        },

        setResult(item) {
            // this.arrowCounter = -1;
            console.log("item==", item);
            if(item) {
                this.form.patient_id = item.id;
                this.form.patient_name = item.name;
                this.form.patient_phone = item.phone;
                this.form.patient_age = item.age;
                this.form.patient_gender = item.gender;  
                this.parseAge(this.form.patient_age);
                this.form.patient_dob = item.dob;
                this.form.patient_father_husband = item.father_or_husband;
                this.form.district_id = item.district_id;
                this.onChangeDisctrict(item.district_id);
                this.form.upazila_id = item.area_id;
                this.form.patient_address = item.address;


                this.patient_search = "";
                this.filteredPatients = [];
                this.selectedPatient = "";
                this.arrowCounter = -1;
            }
            
        },

        clearPatientInfo() {
            this.form.patient_id = '';
            this.form.patient_name = '';
            this.form.patient_phone = '';
            this.form.patient_age = '';
            this.form.patient_gender = '';  
            this.form.patient_dob = ''; 
            this.form.patient_father_husband = '';
            this.form.district_id = '';
            this.form.upazila_id = '';
            this.form.patient_address = '';
            this.age.years = '';
            this.age.months = '';
            this.age.days = '';
            if(this.form.id && this.appointment) {
                this.form.patient_id = this.appointment.patient_id;
                this.form.patient_name = this.appointment.patient_name;
                this.form.patient_phone = this.appointment.patient_phone;
                this.form.patient_age = this.appointment.patient_age;
                this.form.patient_gender = this.appointment.patient_gender;  
                this.form.patient_dob = this.appointment.patient_dob;
                this.form.patient_father_husband = this.appointment.patient_father_husband;
                this.form.district_id = this.appointment.district_id;
                this.onChangeDisctrict(this.appointment.district_id);
                this.form.upazila_id = this.appointment.upazila_id;
                this.form.patient_address = this.appointment.patient_address;
                this.parseAge(this.form.patient_age);
            }

        },

        async onLoadAppointment(appointment_id) {
            if(!appointment_id) return;
            this.editMode = true;
            this.btn='Update';
            this.form.appointment_type = 'appointment';

            const res = await axios.get(this.apiUrl +'/hm/appointments/'+appointment_id, this.headerjson);
            this.appointment = res.data.data;
            this.form.fill(res.data.data); 
            this.parseAge(this.form.patient_age);
            if(this.app_query_type == 'registration') {
                this.form.payment_type = 'cash';
                this.form.appointment_type = 'registration';
                this.btn = 'Confirm with Registration';
                let query = {
                    name: this.form.patient_name,
                    phone: this.form.patient_phone
                };
                // this.searchPatientByNameOrPhone(query);
            }
            if(this.form.department_id != 0) {
                let department_doctors = this.doctors.filter((item, index) => {
                    return item.department_id == this.form.department_id;
                });

                if(department_doctors.length > 0) {
                    this.doctor_options = department_doctors.map((item) => { 
                        return {label:item.name, value:item.id};
                    });
                }
            }
            this.forceRerender();
            this.loadSchedules();
            this.loadSlots();
            setTimeout(() => {
                this.highlightMatchingSchedule('schedule');
                this.highlightMatchingSchedule('slot');
            }, 1000);
        },

        async loadSchedules () {
            if (!this.form.doctor_id) return;
            const res = await axios.get(this.apiUrl +"/hm/doctor_schedules", {
                params: { doctor_id: this.form.doctor_id },
                ...this.headerjson
            });
            this.schedules = res.data.data;
        },

        async loadSlots() {
            if (!this.form.doctor_id || !this.form.appointment_date) return;
            const response = await axios.get(this.apiUrl +'/hm/doctor-slots', {
                params: { doctor_id: this.form.doctor_id, date: this.form.appointment_date },
                ...this.headerjson
            });
            this.slots = response.data.data;
        },

        edit: function(item) { 
            this.btn='Update';
            this.editMode = true;
            this.toggleModal();
            let department_doctors = this.doctors.filter((doctor, index) => {
                    return doctor.department_id == item.department_id;
            });

            if(department_doctors.length > 0) {
                this.doctor_options = department_doctors.map((item) => { 
                    return {label:item.name, value:item.id};
                });
            }

            this.form.fill(item);  
            this.parseAge(this.form.patient_age);
        },

        submitForm: function(e) {  
            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();                        
            formData.append('appointment_type', this.form.appointment_type);
            formData.append('department_id', this.form.department_id);
            formData.append('doctor_id', this.form.doctor_id);
            formData.append('appointment_date', this.form.appointment_date);
            formData.append('schedule_id', this.form.schedule_id);
            formData.append('appointment_time', this.form.appointment_time);
            formData.append('reporting_time', this.form.reporting_time);
            formData.append('type', this.form.type);
            formData.append('patient_id', this.form.patient_id);
            formData.append('patient_name', this.form.patient_name);
            formData.append('patient_phone', this.form.patient_phone);
            formData.append('patient_age', this.form.patient_age);
            formData.append('patient_gender', this.form.patient_gender);
            if(this.form.appointment_type == 'registration') {
                formData.append('patient_dob', this.form.patient_dob);
                formData.append('patient_father_husband', this.form.patient_father_husband);
                formData.append('district_id', this.form.district_id);
                formData.append('upazila_id', this.form.upazila_id);
                formData.append('patient_address', this.form.patient_address);
                formData.append('payment_type', this.form.payment_type);
                formData.append('amount', this.form.amount);

            }

            if(this.editMode){
                formData.append('_method', 'put');
                if(this.form.appointment_type == 'registration') {
                    var postEvent = axios.post(this.apiUrl+'/hm/appointments/update-registration/'+this.form.id, formData, this.headers);
                } else{
                    postEvent = axios.post(this.apiUrl+'/hm/appointments/'+this.form.id, formData, this.headers);
                }
            }else{  
                var postEvent = axios.post(this.apiUrl+'/hm/appointments', formData, this.headers);
            }           

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.appointment = res.data.data;
                    if(this.appointment.status == 2 && (!this.editMode || this.app_query_type == 'registration')) {
                        this.toggleTokenPrintModal();
                        // Redirect after print modal closes
                        setTimeout(() => {
                            this.redirectAfterPrint();
                        }, 2500);
                    } else {
                        this.redirectAfterPrint();
                    }
                    this.$toast.success(res.data.message);



                    // if((this.app_redirect_url == 'today' || this.app_redirect_url == 'all') && this.appointment.appointment_date == new Date().toISOString().slice(0, 10)) {
                    //     this.redirectRoute('/today-appointments');
                    // }else if(this.app_redirect_url != null) {
                    //     this.redirectRoute('/appointments');
                    // }

                }else{
                    this.$toast.error(res.data.message);
                } 
                this.resetForm();
            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                } 
            });
        }, 

        redirectAfterPrint() {
            if((this.app_redirect_url == 'today' || this.app_redirect_url == 'all') && this.appointment.appointment_date == new Date().toISOString().slice(0, 10)) {
                this.redirectRoute('/today-appointments');
            }else if(this.app_redirect_url != null) {
                this.redirectRoute('/appointments');
            }
        },

        validation: function (...fiels){ 
            var obj = new Object(); 
            var validate = false;
            for (var k in fiels){     // Loop through the object  
                for (var j in this.form){  
                    if((j==fiels[k]) && (!this.form[j])) {  
                        obj[fiels[k]] = fiels[k].replace("_", " ")+' field is required';  // Delete obj[key]; 
                        this.errors = {...this.errors, ...obj};
                    }else{
                        validate = false;
                    }
                }              
            }  
        },

        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },

        resetForm() {
            this.editMode = false;
            this.btn = 'Create';
            this.form.reset();
            this.errors = {};
            this.schedules = [];
            this.slots = [];
            this.forceRerender();
            if(this.appointment_id) {
                this.onLoadAppointment(this.appointment_id);
            }
        },

        // For Pagination 
        getAppointmentList(url = this.apiUrl+'/hm/appointments/list') {
            this.tableData.draw++;
            axios.get(url, {params:this.tableData,  headers:this.headerparams})
            .then((response) => {
                let data = response.data.data; 
                if(this.tableData.draw = data.draw) {
                    this.appointments = data.data.data;
                    this.configPagination(data.data);
                }
            })
            .catch(errors => {
                this.$toast.error(errors.response.data.message);
            })
            .finally((fres) => {
                this.loading = false;
            });
        },


    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {}
}
</script>
<style scoped>
    .modal-content.scrollbar-width-thin {
        border: none !important;
        width: 700px
    }

    label {
        display: inline-block;
        margin: 0px 0px 4px 2px;
        float: left;
    }

    .invalid-feedback {
        display: block;
        width: 100%;
        margin-top: 0.25rem;
        font-size: 80%;
        color: #dc3545;
        text-align: left;
    }


    /** For Invoice Print */
	#printTokenReceipt .page {
		border: 1px solid #000;
		padding: 10px;

	}
	#printTokenReceipt .header {
		text-align: center;
		border-bottom: 1px solid #000;
		padding-bottom: 5px;
	}
	#printTokenReceipt .header h2 {
		margin: 0;
		font-size: 16px;
	}
	#printTokenReceipt .header small {
		font-size: 11px;
	}
	#printTokenReceipt .section {
		margin-top: 8px;
	}
	#printTokenReceipt .row {
		display: flex;
		justify-content: space-between;
	}
	#printTokenReceipt .col-50 { width: 50%; }
	#printTokenReceipt .col-60 { width: 60%; }
	#printTokenReceipt .col-40 { width: 40%; }
	#printTokenReceipt .label { font-weight: bold; }
	#printTokenReceipt table {
		width: 100%;
		border-collapse: collapse;
		margin-top: 5px;
	}

	#printTokenReceipt .patient_app_info {
		line-height: 1.6;
	}
	#printTokenReceipt td, th {
		border: 1px solid #000;
		padding: 3px;
		vertical-align: top;
	}
	#printTokenReceipt .no-border td {
		border: none;
	}
	#printTokenReceipt .line-box {
		height: 40px;
		/* border-bottom: 1px solid #000; */
		margin-bottom: 4px;
	}
	#printTokenReceipt .divider {
		border-top: 1px solid #000;
		margin: 15px 0;
	}
	#printTokenReceipt .dashed {
		border-top: 1px dashed #000;
		margin: 12px 0;
	}
	#printTokenReceipt .receipt {
		border: 1px solid #000;
		font-size: 12px;
	}
	#printTokenReceipt .receipt-header {
		text-align: center;
		border-bottom: 1px solid #000;
		padding: 4px;
		font-weight: bold;
		min-height: 40px;
	}

    /** Autocomplete */
    .autocomplete {
    position: relative;
    }

    .w-full.rounded.bg-white.border.border-gray-300.px-4.py-2.space-y-1.absolute.z-10 {
        position: absolute;
        z-index: 9999;
    }

    ul.autocomplete-results {
    width: 100% !important;
    margin-top: 39px !important;
    }
    .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    overflow: auto;
    width: 100%;
    }

    .autocomplete-results li {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
    }

    .autocomplete-results li.isActive,
    .autocomplete-results li:hover {
    background-color: #4aae9b;
    color: white;
    }
    /* .autocomplete-results li:first-child {
    font-weight: 600;
    border-bottom: 1px solid #282828;
    margin-bottom: 3px;
    } */
    /* .autocomplete-results li:first-child:hover {
    background-color: inherit;
    color: inherit;
    } */

    .isActive {
    background-color: #dedede;
    }
</style>